export default __webpack_public_path__ + "static/media/pngegg.b58e9f8f.png";